import React, { useState } from 'react';
import { MenuItem, ListItemIcon, ListItemText, Snackbar, Alert } from '@mui/material';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import usePWA from '../hooks/usePWA';

/**
 * Updated to use the new usePWA hook for better consistency
 */
export default function PwaInstallMenuItem({ onAfterClick }) {
  const [toast, setToast] = useState({ open: false, message: '', severity: 'info' });
  const { isInstallable, isInstalled, install } = usePWA();

  if (!isInstallable || isInstalled) return null;

  return (
    <>
      <MenuItem
        onClick={async () => {
          onAfterClick?.();
          const result = await install();
          setToast({
            open: true,
            severity: result.success ? 'success' : 'info',
            message: result.message || (result.needsManual ? 'Follow the instructions to install' : 'Installation failed'),
          });
        }}
      >
        <ListItemIcon>
          <InstallMobileIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Install App" />
      </MenuItem>
      <Snackbar
        open={toast.open}
        autoHideDuration={3500}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          severity={toast.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
}


